export default __webpack_public_path__ + "static/media/0d.5febf048.jpg";